import {
  EnergyClassCode,
  EnergyClassColor,
  OldEnergyClassCode,
  OldEnergyClassColor,
} from '../enums/EnergyClass';

export const energyClassColors = {
  [EnergyClassCode.A]: EnergyClassColor.A,
  [EnergyClassCode.B]: EnergyClassColor.B,
  [EnergyClassCode.C]: EnergyClassColor.C,
  [EnergyClassCode.D]: EnergyClassColor.D,
  [EnergyClassCode.E]: EnergyClassColor.E,
  [EnergyClassCode.F]: EnergyClassColor.F,
  [EnergyClassCode.G]: EnergyClassColor.G,
};

export const oldEnergyClassColors = {
  [OldEnergyClassCode.APlusPlusPlus]: OldEnergyClassColor.APlusPlusPlus,
  [OldEnergyClassCode.APlusPlus]: OldEnergyClassColor.APlusPlus,
  [OldEnergyClassCode.APlus]: OldEnergyClassColor.APlus,
  [OldEnergyClassCode.A]: OldEnergyClassColor.A,
  [OldEnergyClassCode.B]: OldEnergyClassColor.B,
  [OldEnergyClassCode.C]: OldEnergyClassColor.C,
  [OldEnergyClassCode.D]: OldEnergyClassColor.D,
};

export const ENERGY_EFFICIENCY_HASH = '#energy-efficiency';
